import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../Utility/API";
import toast from "react-hot-toast";
import { updateAuth } from "../../Redux/AuthSlice";
import Fleg from "../../Assets/Header/Flag.png";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import SidebarBOT from "../Sidebar/SidebarBOT";
import logo from "../../Assets/Images/logo.png";
import IconA from "../../Assets/sidebar/icon1.png";
import "./Withdrawal.css";
import Eye from "../../Assets/Dasahboard/eye-slash.png";
import { Select } from "antd";

export default function WithdrawalBOT() {
  const { userId, jwtToken } = useSelector((state) => state.Auth);
  const [dash, setdataArray] = useState([]);
  let [Amount, setAmount] = useState(0);
  let [loading, setloading] = useState(false);

  const [IncomeBalance, setIncomeBalance] = useState(0);
  const [Wtype, setWtype] = useState("");
  const [WithdrawalTo, setWithdrawalTo] = useState("");
  const [EditStatus, setEditStatus] = useState("disabled");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const GetUserDetails = async () => {
    try {
      let responce = await API?.post(
        "userdashboard",
        {
          uid: userId,
          type: 2,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      responce = responce.data.data[0];
      setdataArray(responce);
    } catch (e) {
      console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            wtcAuth: false,
            token: null,
            userId: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const GetWithdrawalBalance = async (wtype) => {
    try {
      let response = await API?.post(
        `/Userreport`,
        {
          uid: userId,
          report: "withdralbalance",
          status: "2",
          fdate: "",
          tdate: "",
          search: "",
          level: "0",
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      response = response.data.data[0][0];
      console.log("Direct_API", response);

      setIncomeBalance(0);
      setEditStatus("");
      setAmount(0);

      if (wtype === "Working") {
        setIncomeBalance(response?.workingbalance);
        setEditStatus("");
      } else if (wtype === "ROI") {
        setIncomeBalance(response?.ROIBalance);
        setEditStatus("");
      } else if (wtype === "FOREXPricipal") {
        setIncomeBalance(response?.FOREXPricipal);
        setAmount(response?.FOREXPricipal);
        setEditStatus("disabled");
      } else {
        setIncomeBalance(0);
        setEditStatus("");
        setAmount(0);
      }
    } catch (e) {
      console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            wtcAuth: false,
            token: null,
            userId: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  const handleChange_Level = (value) => {
    setWtype(value);
    GetWithdrawalBalance(value);
  };

  const handleChangeTo = (value) => {
    setWithdrawalTo(value);
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Loader component
  const Loader = () => (
    <div className="loader text-center">
      <Spinner animation="border" variant="primary" />
      <p>Loading...</p>
    </div>
  );

  const Loader2 = () => (
    <div className="loader text-center">
      <Spinner animation="border" variant="primary" />
      <p>
        <button className="activate_btn">
          Wait for 15 minutes after last transaction
        </button>
      </p>
    </div>
  );

  const WithdrawalAmount = async (e) => {
    if (!WithdrawalTo || WithdrawalTo === "") {
      toast.error("Select WIthrawal To");
      return;
    } else if (!Wtype || Wtype === "") {
      toast.error("Select WIthrawal Income Type");
      return;
    } else if (parseFloat(Amount) <= 0) {
      toast.error("Select WIthrawal Income Type");
      return;
    } else if (parseFloat(Amount) > parseFloat(IncomeBalance)) {
      toast.error(
        "Insufficient Wallet Balance, Request Amount: " +
          Amount +
          ", Available Balance:" +
          IncomeBalance
      );
      return;
    } else {
      let res = await API.post(
        "Withdrawal_BOT",
        {
          uid: userId,
          Request_amount: Amount,
          Wtype: WithdrawalTo,
          withdrawlby: userId,
          Fromincome: Wtype,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("res-->", res);

      if (res.data.data.result === "Withdrawal request has been sent !!") {
        toast.success("Withdrawal request has been sent !");

        navigate("/DashboardBOT");
      } else {
        toast.error(res.data.data.result);
        return;
      }
    }
  };

  //Notification start
  // const [NotificationCount, setNotificationCount] = useState("");
  // const getNotification = async () => {
  //   try {
  //     let res = await API.get(`/GetNotificationuserCount?uid=${userId}`);
  //     setNotificationCount(res.data.data.result);
  //   } catch (e) {
  //     console.log("Error", e);
  //   }
  // };
  // Notification end

  useEffect(() => {
    GetUserDetails();
    // getNotification();
  }, []);

  return (
    <>
      <div className="container-fluid NewDashboard">
        <div className="row">
          <div
            className={` ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          >
            <SidebarBOT />
          </div>
          <div className="col-lg-2 px-0 order-2">
            <div className="sidebarLeft px-3 position-relative">
              <div className="leftisidelogo">
                <img className="h-100 w-100" src={logo} alt="" />
              </div>
              <ul className="itemssidebar">
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    MAGIC Investment
                  </Link>
                  {dash?.BOTpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    FOREX Investment
                  </Link>
                  {dash?.Forexpackage}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Total Income
                  </Link>
                  ${dash.TotalIncome}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Withdrawal Amount
                  </Link>
                  ${dash.WithDrawal_Amount}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Net Balance
                  </Link>{" "}
                  ${dash?.Net_Balance}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-10 px-0 order-lg-2 order-1">
            <div className="contentside">
              <div className="row mx-0">
                <div className="col-12 px-0">
                  <header className="header ps-0">
                    <div className="hdleft d-flex align-items-center">
                      <div className="namelogo ps-3"></div>
                    </div>
                    <div className="rightside">
                      <div className="dropdown dropdow2 d-none d-md-block">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="text1">
                            <p className="mb-1">ID Number</p>
                            <p className="mb-0 fw-bold text-start">{userId} </p>
                          </span>
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu p-2">
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <div className="dropdown dropdow2 d-block d-md-none">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="#">
                              Id Number <span>{userId}</span>
                            </Link>
                          </li>
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <a href="/DashboardFIX">
                        <button className="btn headerbtn">FIX PLAN</button>
                      </a>
                      <button
                        className="btn border-0 togglebtn"
                        id="togglebtn"
                        onClick={toggleSidebar}
                      >
                        <i
                          className={`fas fa-bars text-white ${
                            isSidebarOpen ? "" : "collapsed"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </header>
                </div>
              </div>
              <div className="row mx-0">
                <div className="col-lg-3"></div>
                <div className="col-lg-6">
                  <div className="card leftsidecardpoint">
                    <div className="card-body">
                      <div className="card-heading">MAGIC Withdrawal</div>
                      <div className="" role="document">
                        <div className="modal-content10">
                          <div className="activation_modal">
                            <div className="popup_net">
                              <div className="addNum">
                                <div className="trxnumber text-black">
                                  <span
                                    className="text-black"
                                    style={{ marginLeft: 10 }}
                                  >
                                    Withdrawal Type
                                  </span>
                                  <br />
                                  <Select
                                    defaultValue=""
                                    id="level"
                                    className="floating-input select_bg"
                                    data-val="true"
                                    data-val-required="Level is required"
                                    onChange={handleChange_Level}
                                    options={[
                                      {
                                        value: "",
                                        label: "Select Withdrawal Type",
                                      },
                                      {
                                        value: "Working",
                                        label: "Working Income",
                                      },
                                      {
                                        value: "ROI",
                                        label: "Trading Income",
                                      },
                                      {
                                        value: "FOREXPricipal",
                                        label: "FOREX Principal",
                                      },
                                    ]}
                                  />
                                </div>
                                <div className="trxnumber text-black">
                                  <span
                                    className="text-black"
                                    style={{ marginLeft: 10 }}
                                  >
                                    Withdrawal To
                                  </span>
                                  <br />
                                  <Select
                                    defaultValue=""
                                    id="level"
                                    className="floating-input select_bg"
                                    data-val="true"
                                    onChange={handleChangeTo}
                                    options={[
                                      {
                                        value: "",
                                        label: "Withdrawal To",
                                      },
                                      {
                                        value: "USDT",
                                        label:
                                          "USDT (In E-Currency Address (BEP20))",
                                      },
                                      // {
                                      //   value: "BANK",
                                      //   label: "Bank (In Bank Account(₹))",
                                      // },
                                    ]}
                                  />
                                </div>
                                <div className="trxnumber text-black">
                                  <span
                                    className="text-black"
                                    style={{ marginLeft: 10 }}
                                  >
                                    Withdrawal Balance
                                  </span>
                                  <br />
                                  <input
                                    type="text"
                                    readOnly
                                    value={IncomeBalance}
                                    id="txtamount2"
                                    className="form5"
                                  />
                                </div>
                                <div className="trxnumber text-black">
                                  <span
                                    className="text-black"
                                    style={{ marginLeft: 10 }}
                                  >
                                    Enter Amount
                                  </span>
                                  <br />
                                  <input
                                    type="text"
                                    disabled={Wtype === "FOREXPricipal"}
                                    value={Amount}
                                    id="txtamount2"
                                    className="form5"
                                    onChange={(e) => {
                                      setAmount(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <div
                                    className="trxnumber"
                                    style={{ textAlign: "center" }}
                                  >
                                    {loading == true ? (
                                      <>
                                        <Loader />
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          className="viewalls"
                                          onClick={() => WithdrawalAmount()}
                                        >
                                          Withdrawal
                                        </button>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
